/**
 * User-related utility functions
 */

/**
 * Generate initials from a user/person object
 * Handles various name formats: display_name, full_name, first_name/last_name, email
 *
 * @example
 * getUserInitials({ displayName: 'John Doe' }) // 'JD'
 * getUserInitials({ firstName: 'Jane', lastName: 'Smith' }) // 'JS'
 * getUserInitials({ email: 'user@example.com' }) // 'US'
 * getUserInitials({ fallback: '?' }) // '?'
 */
export function getUserInitials(options: {
  displayName?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  fallback?: string;
}): string {
  const { displayName, fullName, firstName, lastName, email, fallback = 'U' } = options;

  // Priority 1: First name + Last name
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }

  // Priority 2: Display name or Full name
  const name = displayName || fullName;
  if (name) {
    const names = name.trim().split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  // Priority 3: Email
  if (email) {
    return email.slice(0, 2).toUpperCase();
  }

  // Fallback
  return fallback;
}
